import React from 'react'
import CompanyDirectory from 'src/components/CompanyDirectory'

function UsersRoute() {
	return <CompanyDirectory />
}

export default UsersRoute
